function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, Image, ImageBackground, StyleSheet } from 'react-native';
const styles = StyleSheet.create({
  imageContainer: {
    overflow: 'hidden'
  }
});

function KwaiImage({
  style,
  tintColor,
  onLoad,
  children,
  source,
  defaultSource,
  ...props
}) {
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.imageContainer, style]
  }, children ? /*#__PURE__*/React.createElement(ImageBackground, _extends({}, props, {
    style: StyleSheet.absoluteFill,
    source: source,
    defaultSource: defaultSource,
    onLoad: onLoad
  }), children) : /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    style: [StyleSheet.absoluteFill, {
      tintColor: tintColor
    }],
    source: source,
    defaultSource: defaultSource,
    onLoad: onLoad
  })));
}

export default KwaiImage;
//# sourceMappingURL=KwaiImage.web.js.map